<app-base-template (modal)="openModal(content)" (searchmodal)="searchModal()" (dataExportToExcel)="exportToExcel()"
  (tabledata)="getTableData()" [displayData]="displayData" [nextOffset]="nextOffset" [previousOffset]="previousOffset"
  (offset)="getData($event)" (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"
  [showSearch]="showSearch" [showExportBtn]="showExportBtn" [isExportDisable]="isExportDisable"
  [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
  <div class="loader" [hidden]="dataLoaded"><img class="loading-gif" src="../../../assets/img/loader.gif"></div>

  <div class="modal-header modalTitle">
    <div class="modal-title">Map Group with User</div>
  </div>
  <div class="modal-body">
    <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>

    <!-- <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="groupSelected"
              (change)="onGroupChange($event.target.selectedIndex)">
        <option *ngFor="let group of groups" [value]="group.id">{{group.name}}</option>
      </select>
    </div> -->

    <div class="form-group">
      <mat-form-field style="width: 100%;">
        <mat-label>Select Support Groups</mat-label>
        <mat-select [(ngModel)]="groupSelectedArr" multiple (selectionChange)="onGroupChange1()">
          <mat-option *ngFor="let group of groups" [value]="group.id">{{group.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>


    <mat-slide-toggle (toggleChange)="slideChange()" [checked]="slideChecked"> <b class="blue"> Vendor Specific User</b>
    </mat-slide-toggle>
    <!-- <div class="form-group">
      <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="userSelected"
              (change)="onUserChange($event.target.selectedIndex)">
        <option *ngFor="let user of users" [value]="user.id">{{user.name}}</option>
      </select>
    </div> -->


    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="Enter Login ID OR Name"
        [(ngModel)]="userSelected" matInput [formControl]="searchUser" [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="getUserDetails()">
        <mat-option *ngIf="isLoading" class="is-loading">
          <mat-spinner diameter="50"></mat-spinner>
        </mat-option>
        <ng-container *ngIf="!isLoading">
          <mat-option *ngFor="let user of users" [value]="user.login_name">
            {{ user.name }} - {{user.login_name}}
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </div>

    <div class="form-group">
      <input type="text" class="form-control radius-0 font-13" placeholder="User Name" readonly [(ngModel)]="userName">
    </div>

    <mat-slide-toggle (toggleChange)="spocChange()" [checked]="spocChecked"> <b class="blue"> Is a SPOC </b>
    </mat-slide-toggle>

  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>


<ng-template #scarch_content let-c="close" let-d="dismiss">
  <div class="modal-header modalTitle">
    <div class="modal-title">Search</div>
  </div>
  <div class="modal-body">
    <div class="form-group mar_top">
      <input type="text" class="form-control radius-0 font-13" placeholder=" Enter User Name"
        [(ngModel)]="userSelected1">
    </div>
  </div>
  <div class="modal-footer pad-8">
    <button type="button" class="btn btn-success float-right radius-0" (click)="search()">search</button>
    <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
  </div>
</ng-template>
<notifier-container></notifier-container>